import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const u = await login(email, password);
            toast.success(`Bentornato, ${u.full_name}`);
            const home = u.role === "professional" ? "/app/opportunita"
                        : u.role === "facility" ? "/app/annunci" : "/app/admin";
            nav(loc.state?.from?.pathname || home, { replace: true });
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || "Errore di login");
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2">
            <div className="hidden md:block relative">
                <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwZmFjaWxpdHklMjBob3NwaXRhbHxlbnwwfHx8fDE3ODU4NTg1Mjh8MA&ixlib=rb-4.1.0&q=85"
                    alt="" className="absolute inset-0 h-full w-full object-cover" />
                <div className="absolute inset-0 bg-[#1C3F39]/60" />
                <div className="absolute bottom-10 left-10 right-10 text-white">
                    <Link to="/" className="font-display text-2xl font-bold">HealthLink</Link>
                    <p className="mt-4 max-w-md text-white/80">Il marketplace verticale per il settore sanitario italiano.</p>
                </div>
            </div>
            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
                    <h1 className="font-display text-3xl font-bold tracking-tight">Accedi</h1>
                    <p className="mt-2 text-sm text-[#5C5C5C]">Bentornato su HealthLink</p>
                    <div className="mt-8 space-y-4">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                required data-testid="login-email-input" placeholder="tu@esempio.it" className="mt-1" />
                        </div>
                        <div>
                            <Label htmlFor="password">Password</Label>
                            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                                required data-testid="login-password-input" placeholder="••••••••" className="mt-1" />
                        </div>
                        <Button type="submit" disabled={busy}
                            className="w-full bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid="login-submit-btn">
                            {busy ? "Accesso…" : "Accedi"}
                        </Button>
                    </div>
                    <p className="mt-6 text-sm text-[#5C5C5C]">
                        Non hai un account?{" "}
                        <Link to="/register" className="text-[#1C3F39] font-medium underline underline-offset-2" data-testid="login-to-register-link">Registrati</Link>
                    </p>
                </form>
            </div>
        </div>
    );
}
